import { createSelector } from '@reduxjs/toolkit';
import { NavQueryParams } from './DeviceLayout';
import { RootState } from '../../../../redux/store.model';
import {
  getGroupIdQueryParam,
  getGroupSelectedByQueryParamSelector,
  getGroups,
} from '../../../../redux/groups/selectors';
import {
  getDeviceIdFromQueryParam,
  getDeviceSelectedName,
} from '../../../../redux/commander/selectors';
import { navigationPath } from '../../navigations/navigationPath';

const dicTitles: Record<string, string> = {
  history: 'device.monitoring.title',
  incidents: 'incident_manager.title',
};

const getProps = (_: RootState, props: NavQueryParams) => props;

export const getDeviceSectionsNavigationSelector = createSelector(
  [
    getProps,
    getGroupIdQueryParam,
    getDeviceIdFromQueryParam,
    getGroups,
    getGroupSelectedByQueryParamSelector,
    getDeviceSelectedName,
  ],
  (props, groupId, deviceId, groups, group, deviceName) => {
    const url = groupId
      ? `/devicemanager/device/${deviceId}/group/${groupId}/device-detail/`
      : `/devicemanager/device/${deviceId}/device-detail/`;
    const navigators = navigationPath(props, groupId, group).concat([
      {
        content: deviceName || '...',
        onClick: () => {
          navigate(url);
        },
      },
    ]);
    /** module selected */
    const { polyglot, navigate } = props;
    const { pathname } = window.location;
    const moduleSelected = pathname.split('device-detail/')[1] ?? '';

    if (moduleSelected) {
      navigators.push({
        content: polyglot.t(dicTitles[moduleSelected] ?? ''),
        onClick: () => navigate(`${url}/${moduleSelected}`),
      });
    }
    return navigators;
  }
);
